import React from 'react'
import TopLogo from './TopLogo'
import { useNavigate } from 'react-router';
export default function NavTopRight() {
    let type=JSON.parse(localStorage.getItem('userdet'));
    let navigate = useNavigate();
    return (
        <div className='navtop'>
            <TopLogo />
            {type.email}&emsp;
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 13.2353C14.416 13.2353 17.1875 10.2711 17.1875 6.61765C17.1875 2.96415 14.416 0 11 0C7.58398 0 4.8125 2.96415 4.8125 6.61765C4.8125 10.2711 7.58398 13.2353 11 13.2353ZM16.5 14.7059H14.1324C13.1785 15.1746 12.1172 15.4412 11 15.4412C9.88281 15.4412 8.82578 15.1746 7.86758 14.7059H5.5C2.46211 14.7059 0 17.3392 0 20.5882V21.3235C0 22.5414 0.923828 23.5294 2.0625 23.5294H19.9375C21.0762 23.5294 22 22.5414 22 21.3235V20.5882C22 17.3392 19.5379 14.7059 16.5 14.7059Z" fill="black" />
            </svg>
            <div className='navtopoption'>
                <div>{type.first_name+' '+type.last_name}</div>
                <div>{type.type_of_account}</div>
                <div style={{color:'#000747',textDecoration:'underline',cursor:'pointer'}} onClick={()=>{
                    localStorage.removeItem('access');
                    localStorage.removeItem('refresh');navigate('/signin');
                    }}>Logout</div>
            </div>
        </div>
    )
}
